// Session 1 icon should never be grayed out
// The user always has session 1 unlocked
// Import the colored icon just for consistency
import Session1 from "../color/session1.svg";

import Session2 from "./session2grayscale.svg";
import Session3 from "./session3grayscale.svg";
import Session4 from "./session4grayscale.svg";
import Session5 from "./session5grayscale.svg";
import Session6 from "./session6grayscale.svg";
import Session7 from "./session7grayscale.svg";
import Session8 from "./session8grayscale.svg";

const GrayscaleSessionicons = [
  Session1,
  Session2,
  Session3,
  Session4,
  Session5,
  Session6,
  Session7,
  Session8,
];

export default GrayscaleSessionicons;
